module.exports = __webpack_public_path__ + "static/media/Annotation-pana.7c102885.svg";